/* eslint-disable no-console */

import {
  BONUS_FETCH_REQUEST,
  BONUS_FETCH_SUCCESS,
  BONUS_FETCH_FAILURE,
  BONUS_TAKE_REQUEST,
} from "@shared/constants";
import { post, checkResponse } from "@shared/utils/server";
import { put, call, fork, takeLatest, all } from "redux-saga/effects";

import { checkUser } from "./user";

export function* fetchBonus() {
  try {
    const response = yield call(post, {
      method: "Bonus.getActive",
      args: {},
    });

    checkResponse(response);

    yield put({
      type: BONUS_FETCH_SUCCESS,
      payload: { bonus: response[0] },
    });
  } catch (error) {
    yield put({
      type: BONUS_FETCH_FAILURE,
      payload: error,
    });
  }
}

export function* takeBonus() {
  try {
    yield call(post, {
      method: "Bonus.use",
      args: {},
    });

    yield call(fetchBonus);
    yield call(checkUser);
  } catch (error) {
    console.error(error);
  }
}

function* watchBonusFetch() {
  yield takeLatest(BONUS_FETCH_REQUEST, fetchBonus);
}

function* watchBonusTake() {
  yield takeLatest(BONUS_TAKE_REQUEST, takeBonus);
}

export default function* bonusSaga() {
  yield all([fork(watchBonusFetch), fork(watchBonusTake)]);
}
